import { Pipe, PipeTransform } from '@angular/core';
import { ImageCacheService } from '../services/image-cache.service';
import { NO_PHOTO } from '../utils/no-photo';

@Pipe({
    name: 'cachedImage',
    pure: false // важно: пайп небезопасный (асинхронный), т.к. использует Promise
    ,
    standalone: false
})
export class CachedImagePipe implements PipeTransform {
  constructor(private imageCache: ImageCacheService) {}
  
  private cache = new Map<any, string>();

  transform(obj: { image?: string; type?: string } | null | undefined): string {
    if (!obj) return this.getFallback(null);

    // Если кеш уже есть — вернуть его
    if (this.cache.has(obj)) {
      return this.cache.get(obj)!;
    }

    const imageUrl = obj.image?.trim();
    if (!imageUrl) {
      const fallback = this.getFallback(obj.type);
      this.cache.set(obj, fallback);
      return fallback;
    }

    // Асинхронная подгрузка и кеширование
    this.imageCache.getImage(imageUrl).then(cachedUrl => {
      this.cache.set(obj, cachedUrl);
    }).catch(err => {
      console.error('Ошибка загрузки изображения:', err);
      const fallback = this.getFallback(obj.type);
      this.cache.set(obj, fallback);
    });

    // Пока загружается — возвращаем временно fallback
    return this.getFallback(obj.type);
  }

  private getFallback(type: string | null | undefined): string {
    switch (type) {
      case 'food':
        return NO_PHOTO.food;
      case 'drink':
        return NO_PHOTO.drink;
      case 'modificator':
        return 'assets/no_photo_mod_ru.png';
      default:
        return 'assets/no_photo_ru.png';
    }
  }
}